import Quill from 'quill'
const Clipboard = Quill.import('modules/clipboard')
const Delta = Quill.import('delta')

class PlainClipboard extends Clipboard {
	onCapturePaste(e) {
		e.preventDefault()
		const range = this.quill.getSelection()
		const text = e.clipboardData.getData('text/plain')
		const delta = new Delta()
			.retain(range.index)
			.delete(range.length)
			.insert(text)
		const index = text.length + range.index
		const length = 0
		this.quill.updateContents(delta, Quill.sources.USER)
		this.quill.on('selection-change', (newRange, oldRange, source) => {
			if (source === 'api') {
				this.quill.setSelection(index, length, Quill.sources.SILENT)
				this.quill.scrollIntoView()
			}
		})
	}
}

export default PlainClipboard
